import { getOwnConfig, macroCondition } from '@embroider/macros';

export default (await import(
  macroCondition(getOwnConfig().isSsrBuild)
    ? 'rise-ui/stub/services/debug/time-series-output.js'
    : 'rise-ui/stubbed/services/debug/time-series-output.js'
)).default;
